var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 11.1005H8.6665V9.76717H3.33317V11.1005ZM3.33317 8.43384H8.6665V7.1005H3.33317V8.43384ZM1.99984 13.7672C1.63317 13.7672 1.31928 13.6366 1.05817 13.3755C0.797059 13.1144 0.666504 12.8005 0.666504 12.4338V1.76717C0.666504 1.4005 0.797059 1.08662 1.05817 0.825505C1.31928 0.564393 1.63317 0.433838 1.99984 0.433838H7.33317L11.3332 4.43384V12.4338C11.3332 12.8005 11.2026 13.1144 10.9415 13.3755C10.6804 13.6366 10.3665 13.7672 9.99984 13.7672H1.99984ZM6.6665 5.1005V1.76717H1.99984V12.4338H9.99984V5.1005H6.6665Z",
    fill: "#1C1B1F",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTypeIcon);
export default __webpack_public_path__ + "static/media/DocumentTypeIcon.045511f9e20e033594f84bdc254046f2.svg";
export { ForwardRef as ReactComponent };